import { fetchProductImage } from '@/api/productImage.api';
import { EGobeletType } from '@/littleWedding/EGobeletType';
import { EProductImageType } from '@/typescript/enums/EProductImageType';
import type { IProductImage } from '@/typescript/interfaces/IProductImage';
import type { TSides } from '@/typescript/interfaces/TSide';

async function getGridUrl(side: TSides, productType: string, images: IProductImage[]) {
    if (productType.includes(EGobeletType.SMALL)) {
        return '/images/grid_33.png';
    }
    if (productType.includes(EGobeletType.BIG)) {
        return '/images/grid_50.png';
    }

    const imgType = side === 'recto' ? EProductImageType.HELP_GRID_RECTO : EProductImageType.HELP_GRID_VERSO;

    const productImage = images.find((img) => img.type === imgType);

    if (!productImage) {
        return undefined;
    }

    const image = await fetchProductImage(productImage.uuid);

    return URL.createObjectURL(image);
}

export { getGridUrl };
